import * as React from 'react';
import { AccountCircle } from '@mui/icons-material';
import { Menu, MenuItem, Button, Avatar, Box, useTheme } from '@mui/material';
import { useAuth } from '@/hooks';
import { useNavigate } from 'react-router-dom';

export const Account: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { hasLogged, member, clearAccessToken } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  function _close() {
    setAnchorEl(null);
  }

  const handleLogin = () => {
    navigate('/login', { replace: true });
  };

  const handleLogout = () => {
    _close();
    clearAccessToken();
  };

  const handleProfile = () => {
    _close();
    navigate(`/profile/${member?.username}`);
  };

  return (
    <Box mx={0.5}>
      {hasLogged ? (
        <>
          <div
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
          >
            {member?.avatar ? (
              <Avatar
                sx={{
                  width: theme.spacing(4.5),
                  height: theme.spacing(4.5),
                }}
                alt={member.username}
                src={member.avatar}
              ></Avatar>
            ) : (
              <Avatar
                sx={{
                  width: theme.spacing(4.5),
                  height: theme.spacing(4.5),
                }}
                alt={member?.username}
              >
                <AccountCircle />
              </Avatar>
            )}
          </div>
          <Menu
            id="account-menu"
            anchorEl={anchorEl}
            // keepMounted
            open={Boolean(anchorEl)}
            onClose={_close}
          >
            <MenuItem onClick={handleProfile}>个人中心</MenuItem>
            <MenuItem onClick={handleLogout}>退出</MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <Button onClick={handleLogin}>登录</Button>
        </>
      )}
    </Box>
  );
};

export default Account;
